<template>
  <div class="pt-2 secondary">
    <div class="text-h6 text-center mb-2">{{ groupName }} | {{ itemName }}</div>

    <v-text-field
      label="Title"
      color="primary"
      dense
      outlined
      hide-details
      dark
      class="mb-2"
    ></v-text-field>

    <v-textarea
      dense
      outlined
      hide-details
      dark
      color="primary"
      class="mb-4"
      no-resize
      label="Description"
    ></v-textarea>

    <v-text-field
      dense
      outlined
      dark
      color="primary"
      class="mb-4"
      no-resize
      label="Starts at"
      hint="Enter the starting point of audio (Minute:Seconds)"
      persistent-hint
    ></v-text-field>

    <v-text-field
      dense
      outlined
      dark
      color="primary"
      class="mb-4"
      no-resize
      label="Ends at"
      hint="Enter the ending point of audio (Minute:Seconds)"
      persistent-hint
    ></v-text-field>

    <v-checkbox
      dark
      :ripple="false"
      color="primary"
      dense
      hide-details
      class="pa-0 ma-0 mb-4"
      label="Show Player Controls"
    ></v-checkbox>

    <v-file-input
      accept="audio/*"
      v-model="audio"
      ref="audio"
      id="audioInput"
      v-show="false"
    >
    </v-file-input>

    <v-row class="mb-5">
      <v-col cols="2">
        <div class="file-wrapper rounded">
          <label
            class="
              d-flex
              flex-column
              align-center
              justify-center
              add-file
              primary
              pa-2
              rounded
            "
            for="audioInput"
          >
            <v-icon color="white" class="mb-2">mdi-plus</v-icon>
            <div class="body-2 white--text text-center">Add Audio</div>
          </label>
        </div>
      </v-col>

      <v-col cols="2">
        <div class="file-wrapper rounded" v-if="audio">
          <div
            class="
              file-overlay
              d-flex
              flex-column
              align-center
              justify-center
              rounded
            "
          >
            <div class="caption font-weight-bold white--text text-center">
              {{ audio.name }}
            </div>

            <v-btn icon small color="error" @click="deleteAudio()">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["groupName", "itemName"],
  data() {
    return {
      audio: null,
    };
  },
  methods: {
    deleteAudio() {
      this.audio = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.file-wrapper {
  padding-bottom: 100%;
  position: relative;

  .file-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(#000, 0.4);
    z-index: 1;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .add-file {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    cursor: pointer;
  }
}
</style>